export const brandColors = {
  brandOne: '#11B67A',
  brandTwo: '#000000',
} as const;
